const WINDOW_WIDTH = 10;

export {WINDOW_WIDTH};
